/*
* IMPORTANT: la modificació d'aquesta funció pot tenir efectes col·laterals a cada un dels fitxers de filtres de coherència
* on es fa servir, ja que està provada unitàriament però en cap cas està provada la integració amb el codi que la utilitza
*
* Funció auxiliar que donat un identificador d'una variable i un llistat de grup/variables retorna l'objecte sencer d'aquesta variable
* S'utilitza per realitzar cerques dins del llistat
* Es fan exportables per realitzar els tests i treballar amb TDD
***/
export const obteVariable = (idVariable, variables) => {
    let variableARetornar;

    const obteVariableCallback = (variable) => {
        if (variable.idVariable === idVariable) {
            variableARetornar = variable;
        }
        return;
    };

    for (let indexGrup in variables) {
        if (variables.hasOwnProperty(indexGrup) && typeof variables[indexGrup] === 'object') {
            variables[indexGrup].forEach(obteVariableCallback);
        }
    }

    return variableARetornar;
};


/*
* Funció auxiliar que donat un objecte d'una variable retorna el seu valor.
* El valor pot provenir de la propietat 'valor' o de la propietat 'valorNou'
* Es fan exportables per realitzar els tests i treballar amb TDD
***/
export const obteValorVariable = (variable) => {

    if (!variable) {
        return null;
    }

    let valorVariable;

    if (variable.hasOwnProperty('valorNou')) {
        valorVariable = variable.valorNou;
    } else if (variable.hasOwnProperty('valor')) {
        valorVariable = variable.valor;
    } else {
        valorVariable = null;
    }

    // Transformem els valors numèrics de String a Number per tal de poder
    // fer els càlculs necessaris en els filtres de coherència
    if (variable.tipus === 'Numeric' && valorVariable != null) {
        valorVariable = parseFloat(valorVariable);
    }

    return valorVariable;
};


/*
* Funció auxiliar que donat un objecte de tipus variable i un missatge d'error l'afegeix al seu array d'errors
* Es fan exportables per realitzar els tests i treballar amb TDD
***/
export const afegeixErrorAVariable = (variable, error) => {
    variable.errors.push(error);
};



// WEBPACK FOOTER //
// ./src/reducers/observacio/formulari/filtresCoherencia/utils.js